<template>
  <div class="login-container">
    <div class="login-content">
      <h2 class="login-title">睿吃平台后台管理</h2>
      <a-form
        id="components-form-demo-normal-login"
        class="login-form"
        :form="form"
        @submit="login"
      >
        <a-form-item>
          <a-input
            v-decorator="[
              'account',
              { rules: [{ required: true, message: '用户名不能为空' }] }
            ]"
            placeholder="手机号码"
          >
            <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)"/>
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input
            v-decorator="[
              'password',
              { rules: [{ required: true, message: '密码不能为空' }] }
            ]"
            type="password"
            placeholder="密码"
          >
            <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)"/>
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-checkbox
            v-decorator="[
              'remember',
              {
                valuePropName: 'checked',
                initialValue: true
              }
            ]"
          >记住密码</a-checkbox>
          <a-button
            type="primary"
            html-type="submit"
            class="login-form-button"
            :loading="isLoading"
          >登录</a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>
<script>
import { login } from '@/apis/login'
import { storage } from '@/utils/base'
export default {
  data () {
    return {
      isLoading: false
    }
  },
  methods: {
    login (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.isLoading = true
          let formObj = {
            Phone: values.account,
            Password: values.password
          }
          login(formObj).then(res => {
            if (res.data.state === 1) {
              storage.set('token', res.data.attribute.token.access_token)
              storage.set('user', {
                name: res.data.attribute.user,
                roles: res.data.attribute.roles
              })
              let redirectUrl = decodeURIComponent(
                this.$route.query.redirect || 'articles'
              )
              this.$router.push({ path: redirectUrl })
            } else {
              this.$message.error(res.data.message)
            }
            this.isLoading = false
          })
        }
      })
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  }
}
</script>

<style lang="less" scoped>
.login-container {
  height: 100vh;
  padding-top: 200px;
  background-image: url("../assets/images/login_bg.jpg");
  background-size: 100%;
  background-repeat: no-repeat;
  .login-content {
    margin: 0 auto;
    max-width: 300px;
    width: 300px !important;
    .login-title {
      text-align: center;
      color: #333;
      font-weight: bold;
    }
    .login-form-button {
      width: 100%;
    }
  }
}
</style>
